import React from 'react';
import PropTypes from 'prop-types';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import AllocationUnitEditor from '../allocationUnitEditor/AllocationUnitEditor';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';

const initialAllocationUnitState = {
  id: null,
  name: '',
  description: '',
  unitCount: '', 
  unitCountAvailable: 0  
};

class AllocationUnitEditorContainer extends React.Component {
  state = {
    openAllocationUnitEditorSlidingPanel: false,
    saveAllocationUnitDisabled: true,
    isCreation: false, 
    allocationUnitInformation: { ...initialAllocationUnitState },
    minAmountValue : 0
  };

  componentWillReceiveProps(nextProps) {
    if(this.props.creatingAllocationUnit && !nextProps.creatingAllocationUnit) {
      this.setState({ openAllocationUnitEditorSlidingPanel: false });
    }
    if(this.props.fetchingAllocationUnit && !nextProps.fetchingAllocationUnit) {
      this.setState({
        openAllocationUnitEditorSlidingPanel: true,
        allocationUnitInformation: { ...nextProps.allocationUnit },
        isCreation: false,
        minAmountValue: nextProps.allocationUnit.unitCount - nextProps.allocationUnit.unitCountAvailable
      });
    }
    if(!this.state.isCreation && this.props.updatingAllocationUnit && !nextProps.updatingAllocationUnit) {
      this.setState({ openAllocationUnitEditorSlidingPanel: false });
    }
  }

  handleOpenAllocationUnitEditorSlidingPanel = () => this.setState({ openAllocationUnitEditorSlidingPanel: true });

  handleCreateAllocationUnitClick = () => {
    this.setState({ allocationUnitInformation: { ...initialAllocationUnitState }, isCreation: true, minAmountValue: 0 });
    this.handleOpenAllocationUnitEditorSlidingPanel();
  };

  handleCloseAllocationUnitEditorSlidingPanel = () => {
    this.setState({ openAllocationUnitEditorSlidingPanel: false });
  };

  handleSave = () => { 
    if(this.state.isCreation){
      this.props.allocationUnitsActions.createAllocationUnit({ ...this.state.allocationUnitInformation }, this.props.pageState);
    }
    else{
      this.props.allocationUnitsActions.updateAllocationUnit({ ...this.state.allocationUnitInformation }, this.props.pageState);
    }
    this.setState({ ...initialAllocationUnitState, allocationUnitInformation: { ...initialAllocationUnitState.allocationUnitInformation }});    
  };

  isSaveButtonDisabled = state => (
    state.name === '' || 
    state.unitCount < 1  || 
    state.unitCount < this.state.minAmountValue
  );

  handleAllocationUnitFieldChange = (fieldName, value) => this.setState(oldState => {
    const allocationUnitInformation = { ...oldState.allocationUnitInformation, [fieldName]: value };
    return ({ allocationUnitInformation, saveAllocationUnitDisabled: this.isSaveButtonDisabled(allocationUnitInformation) });
  });

  render() {
    
    return (
      <div>
        <SovosButtonsGroup align="right" style={ { marginTop: 25, marginBottom: 15 } }>
          <SovosRaisedButton onClick={ this.handleCreateAllocationUnitClick }>NEW</SovosRaisedButton>
        </SovosButtonsGroup>
        <SovosEditableSlidingPanel
          isDirty={ () => true }
          contentStyle={ { padding: 0 } }
          open={ this.state.openAllocationUnitEditorSlidingPanel }
          onClose={ this.handleCloseAllocationUnitEditorSlidingPanel }
          showCloseButton={ false }
          baseWidth={ '1080px' }
          title={ `${ this.state.isCreation ? 'Create' : 'Update' } Allocation Unit` }
          SaveButtonProps={
            {
              onClick: this.handleSave,
              disabled: this.state.saveAllocationUnitDisabled || this.props.creatingAllocationUnit,
              className: 'allocation-unit-builder__button'
            }
          }
          CancelButtonProps={
            {
              className: 'allocation-unit-builder__button',
              children: 'CANCEL'
            }
          }
          CloseDialogProps={ {
            DialogTitleProps: {
              children: SLIDING_PANEL_DIALOG_TITLE,
              className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
            },
            DialogContentProps: {
              children: SLIDING_PANEL_DIALOG_TEXT,
              className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
            },
            OKButtonProps: {
              children: SLIDING_PANEL_DIALOG_ACTION_LABEL
            },
            CancelButtonProps: {
              children: 'CANCEL'
            }
          } }
        >
          <AllocationUnitEditor
            onCancel={ this.handleCloseAllocationUnitEditorSlidingPanel }
            onSave = { this.handleSave }
            allocationUnit={ this.state.allocationUnitInformation }
            onChangeField={ this.handleAllocationUnitFieldChange }
            saveDisabled={ this.state.saveAllocationUnitDisabled }
            isCreation={ this.state.isCreation }
            minAmountValue={ this.state.minAmountValue }
          />
        </SovosEditableSlidingPanel>
      </div>
    );
  }
}

AllocationUnitEditorContainer.propTypes = {
  creatingAllocationUnit: PropTypes.bool.isRequired,
  fetchingAllocationUnit: PropTypes.bool,
  updatingAllocationUnit: PropTypes.bool.isRequired,
  allocationUnit: PropTypes.object.isRequired,
  pageState: PropTypes.object,
  allocationUnitsActions: PropTypes.shape({
    createAllocationUnit: PropTypes.func,
    updateAllocationUnit: PropTypes.func
  }).isRequired
};

AllocationUnitEditorContainer.defaultProps = {
  pageState: {}
};

export default AllocationUnitEditorContainer;



// WEBPACK FOOTER //
// ./src/components/manageAllocationUnits/comp/allocationUnitEditorContainer/AllocationUnitEditorContainer.js